module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-p-500-353498125f2b8a8b83e05eb9882fde60.jpg";